import clsx from 'clsx';
import React from 'react';

import { Node } from '@tiptap/core';
import { NodeViewContent } from '@tiptap/react';

import type { TextBlockConfig } from '../interfaces';
import {
  alignmentValues,
  backgroundColorValues,
  fontFamilyValues,
  fontSizeValues,
  headingValues,
  marginValues,
  paddingValues,
} from './constants';

function HeadingBlock({
  level,
  config,
}: {
  level: 1 | 2 | 3 | 4 | 5 | 6;
  config?: TextBlockConfig;
}) {
  const headingLevel = `h${level}`;

  return (
    <NodeViewContent
      as={headingLevel as 'div'}
      className={clsx(
        'text-block my-0',
        config?.css_classes,
        alignmentValues[config?.alignment],
        backgroundColorValues[config?.background_color],
        fontFamilyValues[config?.font_family],
        fontSizeValues[config?.font_size],
        headingValues[headingLevel],
        marginValues[config?.margin],
        paddingValues[config?.padding]
      )}
    />
  );
}

export const HeadingBlockNodeExtension = Node.create({
  name: 'headingBlockNodeExtension',
  content: 'heading+',
  group: 'block',
  renderHTML() {
    return ['h1', { class: 'heading-block' }, 0] as const;
  },
});

export default HeadingBlock;
